import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MessageService } from 'primeng/components/common/messageservice';
import { FinanceiroService } from '../financeiro.service';
import { UnidadeService } from '../../shared/services/unidade.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ConfirmationService } from 'primeng/primeng';
import { EditalCredenciamentoService } from '../../editalCredenciamento/edital-credenciamento.service';
import { FaseService } from '../../fase/fase.service';
import { WebPage } from '../../shared/web-page';
import { AuthService } from '../../admin/auth.service';
import { Usuario } from '../../../models/usuario';
import { TipoTransacao } from '../../../models/tipoTransacao';
import { TipoFornecedor } from '../../../models/tipoFornecedor';

@Component({
  selector: 'sispac-entrada-transferencia-form',
  templateUrl: './entrada-transferencia-form.component.html',
  styleUrls: ['./entrada-transferencia-form.component.css']
})
export class EntradaTransferenciaFormComponent extends WebPage implements OnInit {

  @Input() recebeIdTipoTransacao;
  @Output() repostaFormulario = new EventEmitter();
  public tipoFornecedores: any[];
  public fases: any[];
  public tipoDespesas: any[];
  public editais: any[];
  public contas: any[];
  public form: FormGroup;
  public usuario: Usuario;
  public lancamento: any;
  public idLancamento: any;
  public nomeForm: string;

  constructor(messageService: MessageService,
    private fb: FormBuilder,
    private _financeiroService: FinanceiroService,
    private _unidadeService: UnidadeService,
    private _editalCredenciamentoService: EditalCredenciamentoService,
    private _faseService: FaseService,
    private router: Router,
    private authService: AuthService,
    private route: ActivatedRoute,
    private confirmationService: ConfirmationService, ) {
    super(messageService);
    this.buildForm();
    this.usuario = this.authService.informacoesUsuario();
    console.log(this.usuario);
    this.route.paramMap.subscribe(params => {
      if (params.has('id')) {
        this.idLancamento = params.get('id');
      }
    });
  }

  ngOnInit() {
    this.getFasesIdUnidade();
    this.getContas();
    // console.log(this.recebeIdTipoTransacao);
    if (this.idLancamento !== undefined && this.idLancamento !== null) {
      this.getLancamento();
    }

    if (this.router.url.includes('visualizar')) {
      this.form.disable();
    }

    if (this.recebeIdTipoTransacao.toUpperCase() === TipoTransacao.Entrada.toUpperCase()) {
      this.getTipoDespesabyIdFornecedor(TipoFornecedor.Banco);
    } else {
      this.getTipoDespesas();
    }
  }

  buildForm() {
    this.form = this.fb.group({
      idLancamento: [null],
      idControleLancamento: [null],
      idTipoTransacao: [null, [Validators.required]],
      idFase: [null, [Validators.required]],
      idEditalCredenciamento: [null],
      idConta: [null, [Validators.required]],
      idContaDestino: [null, [Validators.required]],
      dataLancamento: [null],
      descricao: [null],
      valor: [null, Validators.required],
      idTipoDespesa: [null, Validators.required],
      idTipoFornecedor: [null],
      idUnidade: [null, Validators.required],
      numeroDocumento: [null],
      idArquivoComprovanteDespesa: [null],
      idUsuarioGestaoSS: null
    });
  }

  setValues() {
    this.form.patchValue({
      idLancamento: this.lancamento.idLancamento,
      idControleLancamento: this.lancamento.idControleLancamento,
      idTipoTransacao: this.lancamento.idTipoTransacao,
      idFase: this.lancamento.idFase,
      idEditalCredenciamento: this.lancamento.idEditalCredenciamento,
      idConta: this.lancamento.idConta,
      idContaDestino: this.lancamento.idContaDestino,
      dataLancamento: this.lancamento.dataLancamento.split('T')[0],
      descricao: this.lancamento.descricao,
      valor: this.lancamento.valor,
      idTipoDespesa: this.lancamento.idTipoDespesa,
      idTipoFornecedor: this.lancamento.idTipoFornecedor,
      idUnidade: this.lancamento.idUnidade,
      numeroDocumento: this.lancamento.numeroDocumento,
      idArquivoComprovanteDespesa: this.lancamento.idArquivoComprovanteDespesa,
    });
  }

  getFasesByIdUnidade() {
    this._faseService.getByUnidade(this.usuario.IdUnidade)
      .finally(() => this.isLoading = false)
      .subscribe(
        fases => this.fases = fases,
        error => this.gerenciaErro(error)
      );
  }

  getFasesIdUnidade() {
    this._faseService.getByUnidade(this.usuario.IdUnidade)
      .finally(() => this.isLoading = false)
      .subscribe(
        fases => this.fases = fases,
        error => this.gerenciaErro(error)
      );
  }

  getTipoFornecedores() {
    this._financeiroService.getAllTipoForcecedores()
      .finally(() => this.isLoading = false)
      .subscribe(
        data => {
          this.tipoFornecedores = data;
        },
        error => {
          this.gerenciaErro(error);
        }
      );
  }

  getContas() {
    this._financeiroService.getAllContas()
      .finally(() => this.isLoading = false)
      .subscribe(
        data => {
          this.contas = data;
        },
        error => {
          this.gerenciaErro(error);
        }
      );
  }

  getTipoDespesas() {

    this._financeiroService.getAllTipoDespesas()
      .finally(() => this.isLoading = false)
      .subscribe(
        data => {
          this.tipoDespesas = data;
        },
        error => {
          this.gerenciaErro(error);
        }
      );
  }

  getTipoDespesabyIdFornecedor(id: string) {
    this._financeiroService.getTipoDespesasByIdFornecedor(id)
      .finally(() => this.isLoading = false)
      .subscribe(
        data => {
          this.tipoDespesas = data;
        },
        error => {
          this.gerenciaErro(error);
        }
      );
  }

  verificaTipoTransacao(id) {
    if (id === '683C2F2A-5A85-40AB-BD81-B64FF79EDD01') {
      this.setValidatorProperty('idTipoDespesa', Validators.required);
      this.removeValidatorProperty('idContaDestino');
      this.form.patchValue({ idContaDestino: null });
    } else {
      this.setValidatorProperty('idContaDestino', Validators.required);
      this.removeValidatorProperty('idTipoDespesa');
      this.form.patchValue({ idTipoDespesa: null });
    }
  }

  setValidatorProperty(propiedade: string, validator) {
    this.form.controls[propiedade].setValidators(validator);
    this.form.controls[propiedade].updateValueAndValidity();
  }

  removeValidatorProperty(propiedade: string) {
    this.form.controls[propiedade].clearValidators();
    this.form.controls[propiedade].updateValueAndValidity();
  }

  getLancamento() {
    // this._financeiroService.getByIdLancamento(this.idLancamento)
    this._financeiroService.getLancamentoSimplificado(this.idLancamento)
      .finally(() => this.isLoading = false)
      .subscribe(
        data => {
          this.lancamento = data;
          this.setValues();
        },
        error => {
          this.gerenciaErro(error);
        }
      );
  }

  cancelar() {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja cancelar?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
        // const arquivosNovos = this.arquivos.controls.filter(arquivo => !arquivo.value.isOld);
        // arquivosNovos.concat(this.arquivosToRemove.controls.filter(arquivo => !arquivo.value.isOld));
        // this.removeArquivosDoBanco(arquivosNovos);
        if (this.idLancamento !== null && this.idLancamento !== undefined) {
          this.router.navigate(['/visualizar-prestacao-conta', this.lancamento.idControleLancamento]);
        } else {
          this.router.navigate(['/gerenciar-prestacao-conta']);
        }
      }
    });
  }

  submit() {
    this.verificaTipoTransacao(this.recebeIdTipoTransacao);
    // console.log('envia form filho');

    this.form.patchValue({
      idTipoTransacao: this.recebeIdTipoTransacao,
      idUnidade: this.usuario.IdUnidade,
      idUsuarioGestaoSS: this.usuario.IdUsuario
    });

    const dataLancamento = this.fomataData(this.form.value.dataLancamento);
    const dataAtual = new Date();

    if (dataLancamento.getTime() > dataAtual.getTime()) {
      this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'O campo data e maior que a data atual!' });
      return;
    }

    // console.log(this.form.value);
    if (!this.form.valid) {
      this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Campos obrigatórios não preenchidos!' });
      return;
    } else {
      // this.repostaFormulario.emit(this.form.value);
      this.isLoading = true;
      this.confirmationService.confirm({
        message: 'Tem certeza que deseja salvar este registro?',
        header: 'Confirmação',
        icon: 'fa fa-question-circle',
        accept: () => {
          this.isLoading = true;
          // console.log(this.form.value);
          this._financeiroService.cadastrarEditarLancamento(this.form.value)
            .finally(() => this.isLoading = false)
            .subscribe(
              data => {
                console.log(data);

                if (this.idLancamento !== null && this.idLancamento !== undefined) {
                  this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Cadastro salvo com sucesso!' });
                  // this.form.reset();
                  this.router.navigate(['/visualizar-prestacao-conta', this.lancamento.idControleLancamento]);
                } else {
                  if (data === 'NAO_E_POSSIVEL_LANCAR_DESPESA') {
                    this.messageService.add({
                      severity: 'warn',
                      summary: 'Atenção',
                      // tslint:disable-next-line: max-line-length
                      detail: 'Não é possível lançar despesas para o mês selecionados, pois a prestação de contas está em análise e aprovação!' });
                  }else if (data === 'ANO_INVALIDO') {
                    this.messageService.add({
                      severity: 'warn',
                      summary: 'Atenção',
                      detail: 'Não é possivel informar uma data com ano inferior que 2018!' });
                  }else {
                    this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: 'Cadastro salvo com sucesso!' });
                    this.form.reset();
                  }
                }
              },
              error => {
                this.isLoading = false;
                this.gerenciaErro(error);
              }
            );
        },
        reject: () => {
          this.isLoading = false;
          this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Dados não enviados!' });
        }
      });
    }
  }

  private fomataData(data) {
    return new Date(data.split('-')[0], (data.split('-')[1] - 1), data.split('-')[2], 0, 0, 0);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/financeiro/entrada-transferencia-form/entrada-transferencia-form.component.ts